import { render, staticRenderFns } from "./SimpleEventCard.vue?vue&type=template&id=0b59b6a6&scoped=true"
import script from "./SimpleEventCard.vue?vue&type=script&lang=js"
export * from "./SimpleEventCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleEventCard.vue?vue&type=style&index=0&id=0b59b6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59b6a6",
  null
  
)

export default component.exports